import React from 'react';
import styles from './LoginForm.module.css';

const ButtonLogin = ({ error }) => {
    return (
        <div className={styles.buttonBox}>
            <button type='submit' className={styles.btn}>
                Se connecter
            </button>
        </div>
    );
};

export default ButtonLogin;